module.exports = __webpack_public_path__ + "static/media/selectedWalletLogo.5e59af68.png";